import PropTypes from 'prop-types'
import { CourseSearchResultsQuery } from '@components/course-search-results'
import GolfCoursesLayout from '@layouts/courses/courses-results-layout'
import { convertFromSlug, transformCasing } from '@utils/slugs'
import { NextSeo } from 'next-seo'
import defaults from '@config/defaults'
import { JsonLd } from '@components/atoms'
import NoSsr from '@material-ui/core/NoSsr'
import GroupEventsNearCity from '@components/group-events-near-city'
import { StatesQuery } from '@components/states'

const GolfCoursesPage = (props) => {
  const {
    query,
  } = props

  const data = {
    breadcrumb: ['Courses', query.state, query.city],
    query,
  }

  const convertedCity = convertFromSlug(query.city)
  const convertedState = query.state.toUpperCase()
  const cityState = `${transformCasing(convertedCity)}, ${convertedState}`
  const cleanQuery = { ...query, city: convertedCity }

  const metaTitle = `Golf Courses in ${cityState} - PGA of America`
  const metaDescription = `Find the nearest golf facilities to you in ${cityState}. Search for public and private golf courses to play golf.`
  const cityURL = `${defaults.baseUrl}play/${query.state}/${query.city}`.toLowerCase()

  return (
    <>
      <NextSeo
        noindex={defaults.noindexNofollow}
        nofollow={defaults.noindexNofollow}
        title={metaTitle}
        description={metaDescription}
        canonical={cityURL}
        openGraph={{
          title: metaTitle,
          type: 'website',
          url: cityURL,
        }}
      />
      <JsonLd {...{
        '@type': 'BreadcrumbList',
        itemListElement: [{
          '@type': 'ListItem',
          position: 1,
          item: {
            '@id': 'https://www.pga.com/play',
            name: 'Golf Courses',
          },
        },
        {
          '@type': 'ListItem',
          position: 2,
          item: {
            '@id': `https://www.pga.com/play/${query.state}`.toLowerCase(),
            name: `${convertedState}`,
          },
        },
        {
          '@type': 'ListItem',
          position: 3,
          item: {
            '@id': `https://www.pga.com/play/${query.state}/${query.city}`.toLowerCase(),
            name: `${transformCasing(convertedCity)}`,
          },
        }],
      }}
      />
      <GolfCoursesLayout data={data}>
        <CourseSearchResultsQuery query={cleanQuery} />
      </GolfCoursesLayout>
      <NoSsr>
        <GroupEventsNearCity city={convertedCity} state={convertedState} />
      </NoSsr>
      <StatesQuery />
    </>
  )
}

GolfCoursesPage.propTypes = {
  query: PropTypes.shape({
    searchText: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
  }),
}

GolfCoursesPage.defaultProps = {}

export default GolfCoursesPage
